# Science & education
https://arxiv.org
https://pubmed.ncbi.nlm.nih.gov
https://nature.com
https://science.org
https://sciencedaily.com
https://phys.org
https://livescience.com
https://scientificamerican.com
https://newscientist.com
https://smithsonianmag.com
https://nationalgeographic.com
https://nasa.gov
https://esa.int
https://space.com
https://skyandtelescope.org
https://earthobservatory.nasa.gov
https://usgs.gov
https://noaa.gov
https://ted.com
https://khanacademy.org
https://coursera.org
https://edx.org
https://ocw.mit.edu
https://openstax.org
https://ck12.org
https://brilliant.org
https://wolframalpha.com
https://mathworld.wolfram.com
https://planetmath.org
https://mathoverflow.net
https://plato.stanford.edu
https://iep.utm.edu
https://britannica.com
https://quantamagazine.org
https://nautil.us
https://aeon.co
https://psyche.co
